import { toast } from "sonner";

interface ToastHandlerOptions {
  description: string;
  variant?: "default" | "destructive" | "success" | "warning" | "info";
  duration?: number;
  title?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function toastHandler({
  description,
  variant = "default",
  duration = 3000,
  title = "Aviso",
  action,
}: ToastHandlerOptions) {
  const message =
    description || "Ocurrió un error inesperado. Intente nuevamente.";

  const actionConfig = action
    ? { label: action.label, onClick: action.onClick }
    : undefined;

  if (variant === "destructive") {
    toast.error(title, {
      description: message,
      duration,
      action: actionConfig,
      style: {
        background: "#fee2e2",
        color: "#b91c1c",
        border: "1px solid #fca5a5",
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(220,38,38,0.08)",
      },
      icon: "❌",
    });
  } else if (variant === "success") {
    toast.success(title, {
      description: message,
      duration,
      action: actionConfig,
      style: {
        background: "#dcfce7",
        color: "#166534",
        border: "1px solid #86efac",
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(34,197,94,0.08)",
      },
      icon: "✅",
    });
  } else if (variant === "warning") {
    toast.warning(title, {
      description: message,
      duration,
      action: actionConfig,
      style: {
        background: "#fef9c3",
        color: "#92400e",
        border: "1px solid #fde68a",
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(251,191,36,0.08)",
      },
      icon: "⚠️",
    });
  } else if (variant === "info") {
    toast.info(title, {
      description: message,
      duration,
      action: actionConfig,
      style: {
        background: "#dbeafe",
        color: "#1e40af",
        border: "1px solid #93c5fd",
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(59,130,246,0.08)",
      },
      icon: "ℹ️",
    });
  } else {
    toast(title, {
      description: message,
      duration,
      action: actionConfig,
    });
  }
}
